import { useEffect, useState } from 'react';
import { Container, Alert, Button } from 'reactstrap';
import { useParams, Navigate } from 'react-router-dom';
import Loader from '../../Layout/Loader';
import { useTranslator } from '../../I18n/useTranslator';

const CouponActivateContainer = ({ activateAccount }) => {
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [preload, setPreload] = useState(true);

  const { token } = useParams();

  const { t } = useTranslator();

  useEffect(() => {
    activateAccountHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const activateAccountHandler = async () => {
    try {
      const response = await activateAccount({ token });
      const { code } = response.data.auth.activateAccount;

      if (code === 200) {
        setSuccess(true);
        setError(false);
        setPreload(false);
      } else {
        setError(true);
        setSuccess(false);
        setPreload(false);
      }
    } catch (e) {
      setSuccess(false);
      setPreload(false);
      throw new Error(`Failed to activate account, got error: ${e}`);
    }
  };

  if (success) {
    return <Navigate to="/auth/confirm" />;
  }

  return (
    <>
      <Container className="py-4">
        <section className="pt-0 text-center">
          {error && (
            <>
              <Alert color="danger">
                <p>{t('activationAccount.error')}</p>
              </Alert>
              <Button color="primary" onClick={() => window.location.reload()}>
                {t('universalError.tryAgain.button')}
              </Button>
            </>
          )}
        </section>
      </Container>
      {preload ? <Loader /> : ''}
    </>
  );
};

export default CouponActivateContainer;
